import React from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import Input from "components/input/inputTextField";
import { Formik } from "formik";
import clsx from "clsx";
// import { DateRangePicker } from "rsuite";
import DateRangePicker from "components/input/dateRangePicker";
import { getLang } from "app/feature/constants";
import { CHECKOUT_LIST_PAGE } from "modules/stockflow/config/stockflow.route";
import BranchSearch from "modules/stockflow/components/select/branchSearch";
import CheckoutListTable from "modules/stockflow/components/table/checkoutListTable";
import CheckoutInitiatorSelect from "modules/stockflow/components/select/checkoutInitiatorSelect";
import ProductSearch from "modules/stockflow/components/select/productSearch";

const useStyle = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    gridTemplateColumns: "4fr 2fr 1fr 1fr 1.6fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  exportButton: {
    backgroundColor: "#ffffff",
    height: 43,
    borderRadius: 4,
    padding: "5px 12px",
    borderColor: "#D0D5DD",
  },
  inputRootID: {
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  filterMainContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: "0px 16px 4px",
    marginBottom: "12px",
  },
  filterFieldContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  paperRoot: {
    width: "217px",
  },
  emptyField: {
    "& .MuiInputBase-root": {
      color: "#A4A6A8",
    },
  },
  datePicker: {
    "& .rs-picker-default .rs-picker-toggle.rs-btn": {
      borderRadius: 4,
      backgroundColor: "#eceff0 !important",
      border: "none !important",
    },
    "& .rs-picker-toggle-value": {
      fontSize: "14px 1important",
    },
  },
}));

export default function CheckoutListingComponent({
  checkouts,
  isFetching,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  totalFiltered,
  page,
  rowsPerPage,
  handleSearch,
  clearSearch,
  handleReload,
  isSearchResult,
  language,
  paginationOptions,
  isFilterOpen,
  setIsFilterOpen,
  tableFilter,
  changeOrder,
  lang,
  resetFilter,
  handleViewDetail,
  productDropdown,
}) {
  const classes = useStyle();

  return (
    <>
      <Formik
        initialValues={{
          branch: tableFilter.branch,
          dateRange: {
            from: tableFilter.fromDate,
            to: tableFilter.toDate,
          },
          search: tableFilter.search,
          checkoutBy: tableFilter.checkoutBy,
          snSearch: tableFilter.snSearch,
          products: tableFilter.products,
          remark: tableFilter.remark,
        }}
        enableReinitialize
        onSubmit={(values, actions) => {
          handleSearch(values);
          actions.setSubmitting(false);
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <Box p={2} mb={0} className={classes.searchContainer}>
              <Input
                hiddenLabel
                variant="filled"
                size="small"
                placeholder={getLang(lang, "placeholder.SEARCH_SERIAL_NUMBER")}
                margin="none"
                InputProps={{
                  disableUnderline: true,
                  margin: "none",
                  style: {
                    borderRadius: "4px",
                    backgroundColor: "#eceff0",
                    minWidth: "50px",
                    height: "100%",
                  },
                  classes: { input: classes.inputRootID },
                }}
                {...formik.getFieldProps("snSearch")}
              />
              <BranchSearch
                placeholder={getLang(lang, "placeholder.BRANCH")}
                value={formik.values.branch}
                handleChange={(value) => formik.setFieldValue("branch", value)}
                isEmpty={formik.values.branch?.length === 0}
                styles={{
                  padding: "0.25em 0.75em",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: 4,
                  width: "100%",
                  overflow: "hidden",
                }}
                handleChipDelete={(branch) => {
                  let temp = [...formik.values.branch];
                  if (temp.length > 0) {
                    const filteredBranchs = temp.filter(
                      (item) => item.node_id !== branch.node_id
                    );
                    temp = [...filteredBranchs];
                  }
                  formik.setFieldValue("branch", temp);
                }}
              />
              <DateRangePicker
                label=""
                placeholder={getLang(lang, "placeholder.SELECT_DATE_RANGE")}
                disabled={isFetching}
                disableFuture={false}
                className={clsx({
                  [classes.emptyField]: !formik.values.dateRange,
                })}
                id={"created-picker-dialog"}
                value={formik.values.dateRange}
                handleChange={(v) => {
                  formik.setFieldValue("dateRange", v);
                }}
                InputPropStyle={{
                  color: !formik.values.dateRange ? "#A4A6A8" : "#000000",
                  fontWeight: "normal",
                }}
                inputProps={{
                  fontWeight: "400",
                  fontSize: "16px",
                }}
                title={getLang(lang, "placeholder.SELECT_DATE_RANGE")}
              />
              <Button
                variant="text"
                disableElevation
                color="secondary"
                size="small"
                disabled={isFetching}
                onClick={() => {
                  clearSearch();
                }}
              >
                {getLang(lang, "label.CLEAR")}
              </Button>
              <Button
                disabled={isFetching}
                variant="contained"
                disableElevation
                color="primary"
                size="small"
                type="submit"
              >
                {getLang(lang, "label.SEARCH")}
              </Button>
            </Box>
            <Box className={classes.filterMainContainer}>
              <Box
                className={classes.filterFieldContainer}
                style={{ marginBottom: "12px" }}
              >
                <CheckoutInitiatorSelect
                  value={formik.values.checkoutBy}
                  handleChange={(value) =>
                    formik.setFieldValue("checkoutBy", value)
                  }
                  placeholder={getLang(lang, "placeholder.CHECKOUT_BY")}
                  disabled={isFetching}
                />
                <ProductSearch
                  searchable={true}
                  value={formik.values.products}
                  placeholder={getLang(lang, "placeholder.SEARCH_BY_PRODUCT")}
                  searchPlaceholder={getLang(
                    lang,
                    "placeholder.SEARCH_A_PRODUCT_NAME"
                  )}
                  isClearable={false}
                  emptyMessage={getLang(
                    lang,
                    "message.info.NO_PRODUCT_FOUND"
                  )}
                  
                  dropdownItem={productDropdown}
                  isEmpty={formik.values.products?.length === 0}
                  selectedProduct={formik.values.products}
                  style={{
                    padding: "0.25em 0.75em",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: 4,
                    width: "100%",
                    overflow: "hidden",
                    height: 36,
                  }}
                  handleSelectAll={(selectAll) => {
                    if (selectAll) {
                      formik.setFieldValue("products", productDropdown);
                    } else {
                      formik.setFieldValue("products", []);
                    }
                  }}
                  handleChange={(value) => {
                    let temp = [...formik.values.products];

                    if (temp.length === 0) {
                      temp.push(value);
                    } else {
                      const isProductExist = temp.find(
                        (product) => product.id === value.id
                      );

                      if (isProductExist === undefined) {
                        temp.push(value);
                      } else {
                        let filter = temp.filter(
                          (product) => product.id !== value.id
                        );

                        temp = [...filter];
                      }
                    }
                    formik.setFieldValue("products", [...temp]);
                  }}
                  handleChipDelete={(product) => {
                    let temp = [...formik.values.products];
                    if (temp.length > 0) {
                      const filteredProducts = temp.filter(
                        (item) => item.id !== product.id
                      );
                      temp = [...filteredProducts];
                    }
                    formik.setFieldValue("products", temp);
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  disabled={isFetching}
                />
                <Input
                  hiddenLabel
                  variant="filled"
                  size="small"
                  placeholder={getLang(lang, "placeholder.SEARCH_REMARK")}
                  margin="none"
                  InputProps={{
                    disableUnderline: true,
                    margin: "none",
                    style: {
                      borderRadius: "4px",
                      backgroundColor: "#eceff0",
                      minWidth: "50px",
                      height: "100%",
                    },
                    classes: { input: classes.inputRootID },
                  }}
                  {...formik.getFieldProps("remark")}
                />
              </Box>
            </Box>
          </form>
        )}
      </Formik>
      <CheckoutListTable
        rows={checkouts}
        isFetching={isFetching}
        isError={isError}
        handleReload={handleReload}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        language={language}
        isSearchResult={isSearchResult}
        totalFiltered={totalFiltered}
        paginationOptions={paginationOptions}
        tableFilter={tableFilter}
        changeOrder={changeOrder}
        lang={lang}
        handleViewDetail={handleViewDetail}
        url={CHECKOUT_LIST_PAGE}
      />
    </>
  );
}
